import { getEnv } from "./Common/Utils/Env";

function getEnvNumberOpt(env: string, defaultValue: number): number {
  const value = import.meta.env[env];
  if (value === undefined) {
    return defaultValue;
  }
  const numValue = Number(value);
  if (isNaN(numValue)) {
    return defaultValue;
  }
  return numValue;
}

export const Config = {
  API_URL: getEnv("VITE_API_URL"),
  APP_GIT_COMMIT: getEnv("VITE_APP_GIT_COMMIT"),
  SENTRY_DSN: getEnv("VITE_SENTRY_DSN"),
  MIXPANEL_TOKEN: import.meta.env.VITE_MIXPANEL_TOKEN as string | undefined,
  STRIPE_PUBLISHABLE_KEY: getEnv("VITE_STRIPE_PUBLISHABLE_KEY"),
  SUPABASE_URL: getEnv("VITE_SUPABASE_URL"),
  SUPABASE_KEY: getEnv("VITE_SUPABASE_KEY"),
  TURNSTILE_SITE_KEY: getEnv("VITE_TURNSTILE_SITE_KEY"),
  // File upload limits
  MAX_UPLOAD_FILES: getEnvNumberOpt("VITE_MAX_UPLOAD_FILES", 5),
  MAX_UPLOAD_SIZE_MB: getEnvNumberOpt("VITE_MAX_UPLOAD_SIZE_MB", 50),
};
